import { useAtomValue } from 'jotai';

import { syncClientConnectionErrorAtom } from '../../session';
import { ClientQueueWrapper as ClientQueue } from './ClientQueueWrapper';
import { ClientsDrawer } from './ClientsDrawer';
import { ClientsInSessionWrapper as ClientsInSession } from './ClientsInSessionWrapper';

export function ClientsDrawerWrapper() {
  const connectionError = useAtomValue(syncClientConnectionErrorAtom);

  return (
    <ClientsDrawer
      clientsInSessionComponent={ClientsInSession}
      clientQueueComponent={ClientQueue}
      connectionError={connectionError}
    />
  );
}
